import { useQuery } from '@tanstack/react-query';
import { insights } from 'config/backendRoutes';
import { useToken } from 'store/hooks/useToken';
import { get } from 'util/fetch';
import { QUERY_KEYS } from './queryKeys';

const ONE_HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
const flowSpecSchemaUrl = `${insights}/flow-spec-schema`;

export const getFlowSpecSchemaApi = token => get(flowSpecSchemaUrl, { token });

export const useGetFlowSpecSchema = ({ enabled = true } = {}) => {
  const token = useToken();

  return useQuery({
    queryKey: [QUERY_KEYS.FLOW_SPEC_SCHEMA, { token }],
    queryFn: async () => getFlowSpecSchemaApi(token),
    staleTime: ONE_HOUR_IN_MILLISECONDS,
    gcTime: ONE_HOUR_IN_MILLISECONDS,
    enabled: enabled && !!token,
  });
};
